const dgaLogoText = "Graph";
const activationsLogoText = "Activations";
const cc10LogoText = "CloudCre10";

export const logoTextMap = {
  "graph.tapad.com": dgaLogoText,
  "graph-stg.tapad.com": dgaLogoText,
  "graph-ui-stg.tapad.com": dgaLogoText,
  "activations.tapad.com": activationsLogoText,
  "cloudcre10-prd.svc.tapad.com": cc10LogoText,
  "cloudcre10-stg.svc.tapad.com": cc10LogoText
};
